import PropTypes from "prop-types";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  FOOTER_ACTIONS,
  FOOTER_LINK_GROUPS,
  LEGAL_LINKS,
  SOCIAL_LINKS,
} from "../../navigation/footer";
import { Button, Link, Typography, shared } from "../../themeV2";
import css from "./Footer.module.css";
import NewsletterSignup from "./NewsletterSignup";

const NEW_TAB = { target: "_blank", rel: "noopener noreferrer" };

const NewTabNote = () => (
  <span className={shared.visuallyHidden}> (opens in new tab)</span>
);

const FooterLink = ({ link }) => (
  <Link
    to={link.to}
    href={link.href}
    external={Boolean(link.external)}
    color="inherit"
  >
    {link.label}
  </Link>
);

FooterLink.propTypes = { link: PropTypes.object.isRequired };

const actionProps = (action) =>
  action.to
    ? { as: RouterLink, to: action.to }
    : { as: "a", href: action.href, ...(action.external && NEW_TAB) };

const LinkGroup = ({ group }) => (
  <div className={css.group}>
    <Typography as="h3" variant="title-sm">
      {group.title}
    </Typography>
    <ul className={css.list}>
      {group.links.map((link) => (
        <li key={link.label}>
          <FooterLink link={link} />
        </li>
      ))}
    </ul>
  </div>
);

LinkGroup.propTypes = { group: PropTypes.object.isRequired };

export default function Footer() {
  return (
    <footer className={css.footer}>
      <div className={css.layout}>
        <h2 className={shared.visuallyHidden}>Site footer</h2>

        <NewsletterSignup className={css.newsletter} />

        <nav aria-label="Footer" className={css.links}>
          {FOOTER_LINK_GROUPS.map((group) => (
            <LinkGroup key={group.id} group={group} />
          ))}
        </nav>

        <div className={css.actions}>
          {FOOTER_ACTIONS.map((action) => (
            <Button
              key={action.id}
              variant={action.variant}
              {...actionProps(action)}
            >
              {action.label}
              {action.external && <NewTabNote />}
            </Button>
          ))}
        </div>

        <ul className={css.social}>
          {SOCIAL_LINKS.map((link) => (
            <li key={link.id}>
              <a className={css.socialLink} href={link.href} {...NEW_TAB}>
                <img
                  src={link.icon}
                  alt=""
                  width="32"
                  height="32"
                  loading="lazy"
                />
                <span className={shared.visuallyHidden}>{link.label}</span>
                <NewTabNote />
              </a>
            </li>
          ))}
        </ul>

        <div className={css.legal}>
          <Typography variant="body-sm" color="variant">
            {`Copyright © ${new Date().getFullYear()} SmashNet`}
          </Typography>
          {LEGAL_LINKS.map((link) => (
            <Typography key={link.label} variant="body-sm" color="variant">
              <FooterLink link={link} />
            </Typography>
          ))}
        </div>
      </div>
    </footer>
  );
}
